"use client";

import { Button } from "@/components/ui/Button";
import { Container } from "@/components/ui/Container";
import { trackClickTranscribeFree } from "@/lib/metrics";
import { siteConfig } from "@/config/site";
import { landingContent } from "@/content/landing";
import { buildAppUrl } from "@/lib/config";
import { appendUtmToUrl } from "@/lib/utm-forward";
import { scrollToAnchor } from "@/lib/scroll-to-anchor";

interface CTAV2Props {
  className?: string;
}

export function CTAV2({ className = "" }: CTAV2Props) {
  const cta = landingContent.cta;
  const isComingSoon = siteConfig.ctaMode === "coming-soon";

  return (
    <section id="cta" className={`relative overflow-hidden py-[40px] ${className}`}>
      {/* Full-bleed gradient stays edge-to-edge; only content aligns to the grid */}
      <div className="absolute inset-0 pointer-events-none" style={{ background: "linear-gradient(180deg, var(--brand-primary-soft) 0%, var(--brand-primary-tint) 62%, #FFFFFF 100%)" }} />

      <Container className="relative flex items-center justify-between gap-[40px] max-tablet:flex-col max-tablet:items-start max-tablet:gap-[24px]">
      <div className="flex flex-col gap-[12px] items-start max-w-[400px] max-tablet:max-w-full">
        <div
          className="[font-family:var(--font-commissioner)] font-bold not-italic text-[32px] leading-[40px] text-text tracking-[-0.64px] whitespace-nowrap max-tablet:whitespace-normal"
          style={{ fontVariationSettings: '"FLAR" 0, "VOLM" 0' }}
        >
          <p className="mb-0">{cta.titleLine1}</p>
          <p>{cta.titleLine2}</p>
        </div>
        <div
          className="[font-family:var(--font-commissioner)] font-medium not-italic text-[18px] leading-[24px] text-text-muted tracking-[-0.36px]"
          style={{ fontVariationSettings: '"FLAR" 0, "VOLM" 0' }}
        >
          <p className="mb-0">{cta.subtitleLine1}</p>
          <p>{cta.subtitleLine2}</p>
        </div>
      </div>

      <Button className="relative shrink-0" onClick={() => {
        trackClickTranscribeFree();
        if (isComingSoon) {
          scrollToAnchor("#pricing");
          return;
        }
        window.open(appendUtmToUrl(buildAppUrl("/login?source=try_free&place=cta_bottom")), "_self");
      }}>{cta.button}</Button>
      </Container>
    </section>
  );
}
